module.exports = __webpack_public_path__ + "static/media/our-mission.806a1454.svg";